export default {
  discount_types: {
    cashback: 'Punti fedeltà',
    promo_code: 'Codice promo',
  },
  input: {
    label: '{{cashbackLabel}} o {{promoCodeLabel}}',
    placeholder: 'Codice promo',
  },
  buttons: {
    apply: 'Applica',
    remove: 'Rimuovi',
  },
  feedback: {
    login:
      "<highlight>Accedi</highlight> per usare questa promo così possiamo verificare che non l'abbia già utilizzata. Accedi e riprova.",
    usage_threshold: 'Importo minimo del carrello per questa promo (esclusi i costi di consegna)',
    promo_code_added: 'Codice promo applicato con successo',
  },
};
